module.exports = __webpack_public_path__ + "299677a51af6977bb2a5d3d1e3e8e812.png";